import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { EventManager } from 'src/app/core';
import { EditComponent } from '../edit.component';
import { ActivatedRoute } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';
import { AppQueries } from 'src/app/state';
@Component({
  selector: 'app-detail-mail-send',
  templateUrl: './detail-mail-send.component.html',
  styleUrls: ['./detail-mail-send.component.scss']
})
export class DetailMailSendComponent extends EditComponent implements OnInit {
  @Input() filterReceiver: any;
  subscriptions?: Subscription[] = [];
  isView: boolean = false;
  isSaved: boolean = false;
  slider: any;
  @Output() result: EventEmitter<any> = new EventEmitter();
  errors: any = {};
  kycStatus = [ {code: 'NOT_ACTIVE', name: 'Chưa kích hoạt' }, {code: 'NOT_FULL_INFO', name: 'Chưa đủ thông tin'}, 
  {code: 'NOT_KYC', name: 'Chưa KYC'}, {code: 'KYC', name: 'Đã KYC'}];
  statusList: any[] = [];
  constructor(
    public eventManager: EventManager,
    private sessionStorageService: SessionStorageService,
    public route: ActivatedRoute,
    private appQueries: AppQueries,
  ) {
    super(eventManager, route)
  }
  ngOnInit() {
    this.subscriptions = [
      this.appQueries.crmStatuses$
      .subscribe((crmStatuses) => {
        this.statusList = crmStatuses;
      }),
    ];
    const params = this.route.snapshot.queryParams;
    this.isView = params.isView;
    if (this.isView) {
      this.detailObject = this.sessionStorageService.retrieve('notification') || {};
      this.detailObject.category = this.detailObject.notificationCategory === 'TRANSACTION' ? 'Giao dịch' : 'Quảng cáo';
      this.filterReceiver = this.detailObject.filterReceiver || {};
      if (this.filterReceiver.mktUserSegmentId) {
        this.detailObject.textList = `Bộ lọc ${this.filterReceiver.mktUserSegmentName}`;
      } else {
        this.detailObject.textList = `Mail chỉ định: ${(this.filterReceiver.receivers || []).join(', ')}`;
      }
      // this.detailObject.issuers = (this.filterReceiver.issuerIds || []).map(item => item.name).join(', ');
      // this.detailObject.products = (this.filterReceiver.productIds || []).map(item => item.name).join(', ');
      // this.detailObject.provinces = (this.filterReceiver.provinceIds || []).map(item => item.name).join(', ');
      // this.detailObject.receivers = (this.filterReceiver.receivers || []).join(', ');
      // this.detailObject.kycStatusCode = (this.kycStatus.find(item => item.code === this.filterReceiver.kycStatusCode) || {code: '', name: ''}).name;
      // this.detailObject.crmStatus = '';
      // this.filterReceiver.crmStatusCodes.forEach((id) => {
      //   const find = this.statusList.find(item => item.id == id) || {};
      //   this.detailObject.crmStatus += (find.name || '') + ', ';
      // })
    }
  }
}
